<template>
  <v-menu bottom offset-y nudge-bottom="8">
    <template v-slot:activator="{ on: menuEvents }">
      <v-btn icon v-on="menuEvents">
        <v-avatar size="32" color="grey lighten-2">
          <v-icon color="grey darken-2">
            mdi-account
          </v-icon>
        </v-avatar>
      </v-btn>
    </template>

    <template v-slot:default>
      <v-card max-width="300">
        <v-list-item two-line class="py-2">
          <v-list-item-content>
            <v-list-item-title>
              Olá, {{ currentUser.nickname || currentUser.name }}!
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ currentUser.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list dense>
          <v-list-item to="/profile">
            <v-list-item-content>
              <v-list-item-title>
                Meu perfil
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-card-actions>
          <v-spacer />

          <v-btn text @click="() => signOut()">
            Sair

            <v-icon size="18" right>
              mdi-logout
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
import { signOut } from '@/services/auth';
import store from '@/services/store';

export default {
  name: 'UserMenu',

  computed: {
    currentUser: () => store.state.auth.currentUser,
  },

  methods: {
    signOut: (...args) => signOut(...args),
  },
};
</script>
